<template>
  <div class="service-support">
    <div class="banner-wrap">
      <img class="support-banner" src="../../assets/images/support_banner.jpg" alt="">
    </div>
    <!-- 服务体系 -->
    <div class="service-system">
      <Title title="服务体系"></Title>
      <ModuleDesc desc="安心保障	贴心服务"></ModuleDesc>
      <div class="service-system-content">
        <div class="service-system-item">
          <div class="system-text">
            <p class="system-title">先进、实用的教学平台</p>
            <p class="system-content">“云+端”全功能板块助力课前、课中、课后教与学。实现教师分层教学、精准教学，学生个性化学习。</p>
          </div>
          <img class="system-img" src="../../assets/images/support/system_1.png" alt="">
        </div>
        <div class="service-system-item service-system-item-bg">
          <img class="system-img" src="../../assets/images/support/system_3.png" alt="">
          <div class="system-text">
            <p class="system-title">标准、高效的课型模式</p>
            <p class="system-content">经长期探索总结出的“三翻二段十环节”教学模式，通过合作学校的实践检验，让课堂教学真正实现了“以学定教，先学后教，以学生为中心”。</p>
          </div>
        </div>
        <div class="service-system-item">
          <div class="system-text">
            <p class="system-title">有温度的驻校教研服务</p>
            <p class="system-content">以驻校教研为核心的高品质运维体系支撑下的教师培训、听评课等高效教研活动有效地促进信息技术与教育教学的深度融合，“走出去、请进来”通过全国性、区域性的多种多样的活动为教师搭建展示交流学习的平台，提升教师职业幸福感。</p>
          </div>
          <img class="system-img" src="../../assets/images/support/system_4.png" alt="">
        </div>
      </div>
    </div>
    <!-- 服务热线 -->
    <div class="service-tel">
      <Title title="服务热线"></Title>
      <div class="service-tel-content">
        <img src="../../assets/images/support_phone.png" alt="">
        <span>400-061-6167</span>
      </div>
    </div>
  </div>
</template>
<script>
import Title from './components/ModuleTitle.vue'
import ModuleDesc from './components/ModuleDesc.vue';
export default {
  components: {
    Title,
    ModuleDesc
  }
}
</script>
<style lang="scss" scoped>
.service-support {
  width: 100%;
  .banner-wrap {
    width: 100%;
    position: relative;
    .support-banner {
      width: 100%;
      // height: 568px;
      display: block;
    }
  }
  .service-system {
    margin-top: 102px;
  }
  .service-system-content {
    margin-top: 20px;
    .service-system-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 80px 0 78px;
      .system-img {
        width: 266px;
        height: 266px;
        margin-left: 64px;
      }
      .system-title {
        font-size: 33px;
        font-weight: 400;
        color: #3E3A39;
        line-height: 31px;
        margin-bottom: 24px;
        text-align: right;
      }
      .system-content {
        font-size: 18px;
        font-weight: 400;
        color: #595757;
        line-height: 30px;
        margin-top: 20px;
        width: 520px;
        text-align: justify;
        text-align-last: right;
      }
    }
    .service-system-item-bg {
      background: #FFFFFF;
      .system-img {
        margin-left: 0;
        margin-right: 64px;
      }
      .system-title {
        text-align: left;
      }
      .system-content {
        text-align: justify;
        text-align-last: left;
      }
    }
  }
  .service-tel {
    margin-top: 160px;
    margin-bottom: 150px;
    .service-tel-content {
      font-size: 36px;
      font-weight: 500;
      color: #595757;
      text-align: center;
      margin-top: 32px;
      img {
        width: 46px;
        height: 46px;
        margin-right: 32px;
        vertical-align: middle;
        border-radius: 50%;
      }
    }
  }
}
</style>